<template>
    <div id="AssetComponents">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div v-if="addAssetComponent == true && assetComponentVal != undefined" class="btn-groups text-right mb-3 border-bottom pb-3">
            <router-link class="btn btn-primary" v-bind:to="{name: 'AssetComponentCreate',query:{asset_id:asset_id_val,flag:'fromView',asset_name:this.$parent.assetData.name}}" > <i class="fp-add"> </i> Add</router-link>
        </div>
        <template v-if="assetComponentVal != undefined">
            <div class="bg-white data-table p-0">
                <vue-good-table
                    ref="listAssetComponentTable"
                    mode="remote"
                    title="Contract"
                    @on-page-change="onPageChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: (totalRecords > serverParams.perPage ? true:false),
                        position: 'bottom',
                        perPage: perPage,
                        perPageDropdown:dropDownPerPage,
                        dropdownAllowAll: false,
                    }"
                    :select-options="{
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                        }"
                    >
                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'action'" class='text-center'>
                                <router-link v-if="updateAssetComponent == true" title="Edit Asset Type" v-bind:key="'action'+index" class="fp-edit" v-bind:to="{name: 'AssetComponentEdit',query:{id:props.row.id,flag:'fromAsset'}}"></router-link>
                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>
                     <div slot="selected-row-actions">
                        <button v-if="deleteAssetComponent == true" id="deleteVehicleTypeBtn" v-on:click.prevent="VehicleComponentDelete" class="btn btn-primary">Delete</button>
                    </div>
                </vue-good-table>
            </div>
        </template>
        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                        <div class="page-title"> Asset Component List</div>
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <div class="btn-groups text-right">
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                            </a>
                            <router-link v-if="addAssetComponent" class="btn btn-primary" v-bind:to="{name: 'AssetComponentCreate',params:{flag:'fromList'}}" >
                                <i class="fp-add"></i>    Add
                            </router-link>
                        </div>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-component-lists">
                        <data-table-filter-config :moduleName="'listAssetComponentTable'" ref="filterComponent" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="bg-white data-table">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'listAssetComponentTable'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listAssetComponentTable"
                                    mode="remote"
                                    title="Contract"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="columns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: asset_component_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    >
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='text-center'>
                                                <router-link v-if="updateAssetComponent == true" title="Edit Asset Type" class="fp-edit" v-bind:to="{name: 'AssetComponentEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else-if="props.column.field == 'unit_no' && canViewAsset === true" class='text-center'>
                                                <router-link title="View Asset Details" class="color-blue"  v-bind:to="{name: 'AssetView',params:{id:props.row.vehicle_id},query:{from:'component'}}">{{props.row.unit_no}}</router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                     <div slot="selected-row-actions">
                                        <button v-if="deleteAssetComponent" id="deleteVehicleTypeBtn" v-on:click.prevent="VehicleComponentDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import EventBus from './../event-bus';
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
var contex
    export default {
        name: "AssetContract",
        mixins:[commonMixins,dataTableMixins],
        props: {
            assetComponentVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            asset_component_value:false,
            columns: [
                 {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: '#Unit',
                    field: 'unit_no',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Component',
                    field: 'component',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Component", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Model',
                    field: 'v_model_code',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Model", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'MFG',
                    field: 'mfg',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MFG", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location',
                    field: 'location',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Install Date',
                    field: 'install_date',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Removal Date',
                    field: 'removal_date',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Syn Lube',
                //     field: 'syn_lube',
                //     hidden:false,
                //     filterable: true,
                //     fpFieldType:"text",
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Syn Lube", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
               /* {
                    label: 'MCP Type',
                    field: 'mcp_type',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MCP Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'In Service Distance',
                    field: 'in_service_distance',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"number",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MCP Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Out of Sync',
                    field: 'out_of_sync',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Out ff Sync", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },*/
                {
                    label: 'Created By',
                    field: 'created_by',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Created By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
//                    sortable:false
                },

            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            asset_id_val:0,
            addAssetComponent:false,
            deleteAssetComponent:false,
            updateAssetComponent:false,
            canViewAsset:false,
            action:'list',
            pageKey:"_asset_component_list_",
        }),
        metaInfo () {
            if (this.assetComponentVal == undefined) {
                return {
                    title: "Asset Component List | " +process.env.COPYRIGHT_NAME
                }
            }
        },
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset_component') {
                            self.cantAccessPage = true;
                            self.asset_component_value = true;
                        }
                        if (permissions[i].name == 'add_asset_component') {
                            self.addAssetComponent = true;
                            self.updateAssetComponent = true;
                        }
                        if (permissions[i].name == 'view_asset') {
                            self.canViewAsset = true;
                        }
                        if (permissions[i].name == 'delete_asset_component') {
                            self.deleteAssetComponent = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        beforeDestroy(){
            this.$root.$off('load');
        },
        mounted: function() {
            var self = this;

            var path = window.location.pathname;
            var asset = path.split("/");
            // this.$root.$on('load', () => {
            // });

            self.asset_id_val = asset[3];

            //when component list directly call from url instead of in view page than call permission request
            if ( self.assetComponentVal == undefined ) {
                self.getPermissions();
            }else{
                self.assetId = asset[3];
                self.assetComponentVal = "loadList";
                self.flag = 'assetComponent';

                    //for now hide unit and name datatable column
                    for (let index = 0; index < this.columns.length; index++) {

                        if (this.columns[index].field == 'unit_no' || this.columns[index].field == 'location' || this.columns[index].field == 'action') {

                            this.$set(this.columns[index], 'hidden', true);
                        }

                    }

                // self.getPermissions();
                self.loadList();
            }
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listAssetComponentTable.unselectAllInternal();
            },
            loadVehicle() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/asset/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {

                            self.isEdit = true;

                            self.stock_no = data.content.stock_no;
                            self.body_length = data.content.body_length;
                            self.engine_model =data.content.engine_model;
                            self.horsepower = data.content.horsepower;
                            self.f_axle_wgt = data.content.f_axle_wgt;
                            self.r_axle_wgt = data.content.r_axle_wgt;
                            self.sleeper_size = data.content.sleeper_size;
                            self.engine_manufacturer = {text:data.content.engine_manufacturer , value:data.content.engine_manufacturer};
                            self.trans_manufacturer = {text:data.content.trans_manufacturer , value:data.content.trans_manufacturer};
                            self.trans_model ={text:data.content.trans_model , value:data.content.trans_model};
                            self.trans_speed = {text:data.content.trans_speed , value:data.content.trans_speed};
                            self.sleeper_type ={text:data.content.sleeper_type , value:data.content.sleeper_type};
                            self.wheelbase =  {text:data.content.wheelbase , value:data.content.wheelbase};
                            self.susp_make = {text:data.content.susp_make , value:data.content.susp_make};
//                            self.fuel_type = {text:data.content.fuel_type , value:data.content.susp_make};
                            self.fuel_type = data.content.fuel_type;
                            self.dot = data.content.dot;
                            self.engine_size = data.content.engine_size;
                            self.overhaul = data.content.overhaul;
                            self.engine_brake = data.content.engine_brake;
                            self.ratio = data.content.ratio;
                            self.overdrive = data.content.overdrive;
                            self.differential_lock = data.content.differential_lock;
                            self.new_used = {text:data.content.new_used , value:data.content.new_used};
                            self.transmission = {text:data.content.transmission , value:data.content.transmission};

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'load-asset-component')
                    }
                });
            },
            exportReports: function() {
                var self = this;
                this.action = "export";
                this.loadList();
            },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
            },
            loadList() {

                var self = this;

                self.loading = true;
                if( self.assetComponentVal == 'dontLoadList' ){
                    return;
                }
                var data = this.$refs['listAssetComponentTable'].selectedRows;
                var selectedRows = [];

                for (var i = 0; i < data.length; i++) {
                    selectedRows.push(self.$refs['listAssetComponentTable'].selectedRows[i].id)
                }
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    all:self.serverParams.selectedAll,
                    selectedRows:selectedRows,
                    action:self.action,
                    flag: self.flag,
                    vehicle_id: self.assetId
                };
                self.firstLoad = 1;

                $.ajax({
                    url: process.env.ROOT_API + "/assetcomponent/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if ( self.action == "export" ) {
                                self.action = "";
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);

                                }
                                    self.loadList();
                            }else if ( self.action == "delete" ) {

                                self.action = "list";
                                $("#deleteVehicleTypeBtn").val("Delete");

                                self.$refs.filterComponent.clearSelectAll();
                                self.loadList();
                                EventBus.$emit('clear-all-flags', false);   //hide alert of selection

                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if ( self.action == "delete" ) {
                            self.generateStatusCodeMessage(jqXHR, true, 'load-asset-component-delete');
                        }else{
                            self.generateStatusCodeMessage(jqXHR, false, 'load-asset-component-list');
                        }
                    }
                });
            },
            VehicleComponentDelete() {
                if (confirm('Are you sure that you want to delete this Asset Component? ')) {

                    this.action = "delete";
                    $("#deleteVehicleTypeBtn").val("Deleting ...");

                    this.loadList();

                }
                /*var data = this.$refs['listAssetComponentTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listAssetComponentTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Asset Component? ')) {
                    self.loading = true;
                    $("#deleteVehicleTypeBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/assetcomponent/delete",
                        type: "POST",
                        data: 'id=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteVehicleTypeBtn").val("Delete");
                            }, 10000);

                            if (data.code == '200') {
                            self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('tkn');

                                    self.$router.push("/");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }*/
            }
        }
    };

</script>




// WEBPACK FOOTER //
// src/components/asset/AssetComponentList.vue